(() => {
    if (window.__digitalAckInit) return;
    window.__digitalAckInit = true;

    const syncGates = (checked) => {
      document.querySelectorAll('[data-digital-ack-checkbox]').forEach((box) => {
        box.checked = checked;
      });
      document.querySelectorAll('[data-digital-ack-gate]').forEach((gate) => {
        gate.toggleAttribute('data-ack-pending', !checked);
        const btn = gate.querySelector('#checkout, .cart__checkout-button');
        if (btn) btn.toggleAttribute('disabled', !checked);
      });
    };

    const saveAck = (stamp, attempt) => {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Digital no-refund acknowledged': stamp } }),
      }).then(
        () => verifyAck(stamp, attempt),
        () => verifyAck(stamp, attempt)
      );
    };

    const verifyAck = (stamp, attempt) => {
      return fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const saved = cart && cart.attributes && cart.attributes['Digital no-refund acknowledged'];
          if (stamp && !saved) throw new Error('not saved');
        })
        .catch(() => {
          if (attempt < 1) return saveAck(stamp, attempt + 1);
          if (stamp) {
            // save PROVABLY failed twice: re-lock so no order lacks the record
            syncGates(false);
          }
        });
    };

    document.addEventListener('change', (e) => {
      if (!e.target.matches('[data-digital-ack-checkbox]')) return;
      const checked = e.target.checked;
      // fail-open: reflect the user's choice immediately; never hold the
      // buttons hostage to the network, never disable the checkbox
      syncGates(checked);
      const stamp = checked
        ? new Date().toISOString().slice(0, 16).replace('T', ' ') + ' UTC'
        : '';
      saveAck(stamp, 0);
    });

    // clicking the gated checkout area draws attention to the checkbox
    let distressCount = 0;
    document.addEventListener('click', (e) => {
      const gate = e.target.closest('[data-digital-ack-gate][data-ack-pending]');
      if (!gate) return;
      e.preventDefault();
      distressCount += 1;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          '_ack_locked_clicks': String(distressCount) + ' @ ' + new Date().toISOString().slice(0, 16),
        } }),
      }).catch(() => {});
      const scope = gate.closest('form, .cart__summary, cart-items-component, body') || document;
      const label = scope.querySelector('.cart-digital-ack') || document.querySelector('.cart-digital-ack');
      if (!label) return;
      label.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const hint = label.querySelector('.cart-digital-ack__hint');
      if (hint) hint.hidden = false;
      label.classList.remove('cart-digital-ack--attention');
      void label.offsetWidth; // restart animation
      label.classList.add('cart-digital-ack--attention');
      const box = label.querySelector('[data-digital-ack-checkbox]');
      if (box) box.focus({ preventScroll: true });
    });

    // hide hints once acknowledged
    document.addEventListener('change', (e) => {
      if (!e.target.matches('[data-digital-ack-checkbox]') || !e.target.checked) return;
      document.querySelectorAll('.cart-digital-ack__hint').forEach((h) => { h.hidden = true; });
      document.querySelectorAll('.cart-digital-ack--attention').forEach((l) => l.classList.remove('cart-digital-ack--attention'));
    });

    // health breadcrumb: proves which script version ran for this session
    const markHealth = () => {
      const box = document.querySelector('[data-digital-ack-checkbox]');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          '_ack_js': 'v3-global ' + (box ? 'box-found' : 'no-box-yet') + ' @ ' + new Date().toISOString().slice(0, 16),
        } }),
      }).catch(() => {});
    };
    document.addEventListener('change', (e) => {
      if (e.target.matches && e.target.matches('[data-digital-ack-checkbox]') && e.target.checked) markHealth();
    });

    // initial state on load (server rendered the attribute state; enforce button disable)
    document.addEventListener('DOMContentLoaded', () => {
      const anyBox = document.querySelector('[data-digital-ack-checkbox]');
      if (anyBox) syncGates(anyBox.checked);
    });
  })();
